import http from "@/http/aisea/axios";
const resource = "/enterprises/vessels";

export default {
  //航海一覧取得
  getVoyages(vesselId, params) {
    return http.get(`${resource}/${vesselId}/fuel_consumption_report/voyages`, {
      params: params,
    });
  },

  getSummaryRecord(vesselId, voyageHistoryId) {
    return http.get(
      `${resource}/${vesselId}/fuel_consumption_report/voyages/${voyageHistoryId}/summary`
    );
  },

  getSummaryPeriod(vesselId, params) {
    return http.get(`${resource}/${vesselId}/fuel_consumption_report/summary`, {
      params: params,
    });
  },

  getCsv(vesselId, params) {
    return http.get(
      `${resource}/${vesselId}/fuel_consumption_report/summary/csv`,
      { params: params }
    );
  },

  getCsvAtAnchor(vesselId, params) {
    return http.get(
      `${resource}/${vesselId}/fuel_consumption_report/summary/at_anchor/csv`,
      { params: params }
    );
  },
};
